'use client';

import { usePathname } from 'next/navigation';
type Props = {
  title: string;
  description?: string;
  thumbnailUrl: string;
  contentUrl: string;
};

export default function VideoMetaData({
  title,
  description,
  contentUrl,
  thumbnailUrl,
}: Props) {
  const pathName = usePathname();
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'VideoObject',
    name: title,
    description,
    thumbnailUrl: thumbnailUrl,
    contentUrl: contentUrl,
    embedUrl: pathName,
  };

  return (
    <script
      type='application/ld+json'
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}
